/* Catedo · favoris sans compte (14.09.2026)
   - enregistrés dans le navigateur (localStorage), aucune requête, aucun cookie ;
   - boutons [data-cf-fav="poignée"] sur les fiches et les cartes ;
   - accès : menu déroulant de l'icône compte (« Mes favoris ») ;
   - page : modèle collection.favoris (section catedo-favoris).
   Textes et adresse : window.CatedoFavoris (snippet catedo-favoris-config). */
(function () {
  'use strict';
  var C = window.CatedoFavoris || {};
  var T = C.t || {};
  var KEY = 'catedo-favoris';
  var lus = [];
  try { lus = JSON.parse(localStorage.getItem(KEY) || '[]'); if (!Array.isArray(lus)) lus = []; } catch (e) { lus = []; }
  var favs = lus.filter(function (h) { return typeof h === 'string' && h; });

  function sauve() { try { localStorage.setItem(KEY, JSON.stringify(favs)); } catch (e) {} }
  function a(h) { return favs.indexOf(h) > -1; }

  var css = [
    '.cf-favdd{position:absolute;top:calc(100% + 6px);right:0;z-index:60;min-width:220px;padding:6px;border-radius:10px;background:#fff;border:1px solid #ECE4D7;box-shadow:0 12px 30px rgba(23,23,23,.14);display:none}',
    '.cf-favdd.on{display:block}',
    '.cf-favdd a{display:flex;align-items:center;gap:10px;height:42px;padding:0 10px;border-radius:8px;color:#171717;text-decoration:none;font:600 14px/1 "Nunito Sans",sans-serif;white-space:nowrap}',
    '.cf-favdd a:hover,.cf-favdd a:focus-visible{background:#F6F2EB}',
    '.cf-favdd svg{width:18px;height:18px;flex:none;fill:none;stroke:#5C5A55;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}',
    '.cf-favdd b{margin-left:auto;min-width:22px;height:20px;padding:0 6px;border-radius:10px;background:#FBF7EF;border:1px solid #ECE4D7;font:700 11.5px/18px Poppins,sans-serif;text-align:center}',
    '.cf-favpt{position:absolute!important;display:block!important;top:9px;right:9px;width:9px!important;height:9px!important;min-height:0!important;padding:0!important;margin:0!important;border-radius:50%;background:#E0283F;box-shadow:0 0 0 2px #fff;pointer-events:none}',
    '.cf-favwrap{position:relative;display:flex}',
    '.cf-favdrawer{display:flex;align-items:center;gap:1rem}',
    '.cf-favdrawer svg{width:2rem;height:2rem;fill:none;stroke:currentColor;stroke-width:1.6}',
    '.cf-favdrawer b{min-width:22px;height:20px;padding:0 6px;border-radius:10px;background:#FBF7EF;border:1px solid #ECE4D7;font:700 11.5px/18px Poppins,sans-serif;text-align:center}',
    '.cf-favtoast{position:fixed;left:50%;bottom:24px;z-index:1000;transform:translate(-50%,16px);display:flex;align-items:center;gap:14px;max-width:calc(100vw - 32px);padding:12px 16px;border-radius:10px;background:#171717;color:#fff;font:600 14px/1.25 "Nunito Sans",sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.25);opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease}',
    '.cf-favtoast.on{opacity:1;transform:translate(-50%,0);pointer-events:auto}',
    '.cf-favtoast a{color:#F3C77A;font-weight:700;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}',
    '.cf-favtoast svg{width:18px;height:18px;flex:none;fill:#E0283F;stroke:#E0283F}',
    '@media (prefers-reduced-motion:reduce){.cf-favtoast{transition:none}}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var COEUR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.5-4.6-7.5-10.3A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.7c0 5.7-7.5 10.3-7.5 10.3z"/></svg>';
  var PERSO = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c1.2-3.6 4-5.3 7.5-5.3s6.3 1.7 7.5 5.3"/></svg>';

  /* ── boutons cœur ── */
  function majBoutons() {
    document.querySelectorAll('[data-cf-fav]').forEach(function (b) {
      var on = a(b.getAttribute('data-cf-fav'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? (T.retirer || 'Retirer des favoris') : (T.ajouter || 'Ajouter aux favoris'));
    });
  }

  /* ── message ── */
  var toast, tmr;
  function message(on) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'cf-favtoast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = on
      ? COEUR + '<span>' + (T.ajoute || 'Ajouté à vos favoris') + '</span>' + (C.url ? '<a href="' + C.url + '">' + (T.voir || 'Voir mes favoris') + '</a>' : '')
      : '<span>' + (T.retire || 'Retiré de vos favoris') + '</span>';
    toast.classList.add('on');
    clearTimeout(tmr); tmr = setTimeout(function () { toast.classList.remove('on'); }, 2800);
  }

  /* ── icône compte : point rouge + menu déroulant ── */
  var compte = document.querySelector('.header__icon--account'), dd, compteur;
  if (compte && C.url) {
    var wrap = document.createElement('span'); wrap.className = 'cf-favwrap';
    compte.parentNode.insertBefore(wrap, compte); wrap.appendChild(compte);
    dd = document.createElement('div'); dd.className = 'cf-favdd'; dd.id = 'cf-favdd';
    var connecte = C.connecte === true;
    dd.innerHTML = '<a href="' + compte.getAttribute('href') + '">' + PERSO + (connecte ? (T.compte || 'Mon compte') : (T.connexion || 'Se connecter')) + '</a>' +
      '<a href="' + C.url + '">' + COEUR + (T.mes || 'Mes favoris') + '<b data-cf-favn>0</b></a>';
    wrap.appendChild(dd);
    compteur = dd.querySelector('[data-cf-favn]');
    compte.setAttribute('aria-haspopup', 'true'); compte.setAttribute('aria-expanded', 'false'); compte.setAttribute('aria-controls', 'cf-favdd');
    compte.addEventListener('click', function (e) {
      e.preventDefault();
      var ouvert = !dd.classList.contains('on');
      dd.classList.toggle('on', ouvert); compte.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (ouvert) { var l = dd.querySelector('a'); if (l && e.detail === 0) l.focus(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) { dd.classList.remove('on'); compte.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dd.classList.contains('on')) { dd.classList.remove('on'); compte.setAttribute('aria-expanded', 'false'); compte.focus(); } });
  }
  /* ── mobile : l'icône compte reste masquée (le logo reste centré) ; « Mes favoris » va dans le menu ── */
  var tiroir = document.querySelector('.menu-drawer__account'), lienTiroir, burger = document.querySelector('header-drawer summary');
  if (tiroir && C.url) {
    lienTiroir = document.createElement('a');
    lienTiroir.href = C.url; lienTiroir.className = tiroir.className + ' cf-favdrawer';
    lienTiroir.innerHTML = COEUR + '<span>' + (T.mes || 'Mes favoris') + '</span><b data-cf-favn2>0</b>';
    tiroir.parentNode.insertBefore(lienTiroir, tiroir.nextSibling);
  }
  function point(el, on) {
    if (!el) return;
    var pt = el.querySelector(':scope > .cf-favpt');
    if (on && !pt) { pt = document.createElement('i'); pt.className = 'cf-favpt'; pt.setAttribute('aria-hidden', 'true'); if (getComputedStyle(el).position === 'static') el.style.position = 'relative'; el.appendChild(pt); }
    if (!on && pt) pt.remove();
  }
  function majCompte() {
    if (lienTiroir) lienTiroir.querySelector('[data-cf-favn2]').textContent = favs.length;
    point(burger, favs.length > 0);
    if (!compte || !compteur) return;
    compteur.textContent = favs.length;
    var pt = compte.querySelector('.cf-favpt');
    if (favs.length && !pt) { pt = document.createElement('i'); pt.className = 'cf-favpt'; pt.setAttribute('aria-hidden', 'true'); compte.style.position = 'relative'; compte.appendChild(pt); }
    if (!favs.length && pt) pt.remove();
  }

  function publie() {
    majBoutons(); majCompte();
    document.dispatchEvent(new CustomEvent('catedo:favoris', { detail: { favoris: favs.slice() } }));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cf-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-cf-fav'), i = favs.indexOf(h), on = i < 0;
    if (on) favs.unshift(h); else favs.splice(i, 1);
    sauve();
    b.classList.remove('pop'); void b.offsetWidth; if (on) b.classList.add('pop');
    publie();
    if (!b.hasAttribute('data-cf-fav-silence')) message(on);
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    try { favs = JSON.parse(e.newValue || '[]'); } catch (x) { favs = []; }
    publie();
  });

  window.CatedoFavoris = Object.assign(C, { liste: function () { return favs.slice(); }, retirer: function (h) { var i = favs.indexOf(h); if (i > -1) { favs.splice(i, 1); sauve(); publie(); } } });
  publie();
})();
